import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ConverterService,  OccEndpointsService, PaginationModel } from '@spartacus/core';
import { Observable } from 'rxjs';
import {
  DeliveryNote,
  DeliveryNotesOverview,
  DeliveryNotesOverviewRequest,
} from './delivery-notes.models';

@Injectable()
export class DeliveryNotesAdapter {
  constructor(
    public datepipe: DatePipe,
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}



createQueryData(formData: DeliveryNotesOverviewRequest): DeliveryNotesOverviewRequest {
var queryData: DeliveryNotesOverviewRequest = {
  debitorNumber: formData.debitorNumber, 
  deliveryId: formData.deliveryId, 
  productCode: formData.productCode,
  deliveryDateFrom: '',
  deliveryDateTo: '',
  };

  if (formData.deliveryDateFrom?.length > 0) {
    let fromDate = new Date(formData.deliveryDateFrom);
    queryData.deliveryDateFrom = this.datepipe.transform(fromDate,'dd.MM.yyyy');
   }
  if (formData.deliveryDateTo?.length > 0) {
    let toDate = new Date(formData.deliveryDateTo);
    queryData.deliveryDateTo = this.datepipe.transform(toDate,'dd.MM.yyyy');
   }

return queryData;
}


 getDeliveryNotesOverview(
    formData: DeliveryNotesOverviewRequest
  ): Observable<DeliveryNotesOverview> { 
       return this.http.post<DeliveryNotesOverview>(
      this.occEndpoints.buildUrl('deliveryNotes', {queryParams: this.createQueryData(formData)}),
      null
      );
  }

  getMarketplaceDeliveryNotesOverview(
    formData: DeliveryNotesOverviewRequest
  ): Observable<DeliveryNotesOverview> {
      return this.http.post<DeliveryNotesOverview>(
      this.occEndpoints.buildUrl('marketplaceDeliveryNotes', {queryParams: this.createQueryData(formData)}),
      null
      );
  }

  getDeliveryNote(uigDeliveryNumber: string): Observable<DeliveryNote> {
    const params = {
      deliveryId: uigDeliveryNumber,
    };
    
    return this.http.get<DeliveryNote>(
      this.occEndpoints.buildUrl('deliveryNotesDetail', {urlParams: params})
    );
    
  }

  getMarketplaceDeliveryNote(uigDeliveryNumber: string): Observable<DeliveryNote> {
    const params = {
      deliveryId: uigDeliveryNumber,
    };
    
    return this.http.get<DeliveryNote>(
      this.occEndpoints.buildUrl('marketplaceDeliveryNotesDetail', {urlParams: params})
    );
    
  }

 }
